import actionTypes from "../action-types";
import { MemoryType } from "../models/state/memories/memory/Memory";

export const saveMemoryLocally = (memory: MemoryType): Record<string, any> => {
  return {
    type: actionTypes.SAVE_MEMORY,
    payload: { ...memory }
  };
};

export const receiveMemories = (
  memories: Array<MemoryType>
): Record<string, any> => ({
  type: actionTypes.RECEIVE_MEMORIES,
  payload: {
    memories
  }
});

export const reconcileMemoriesLocally = (memories: Array<MemoryType>) => ({
  type: actionTypes.RECONCILE_MEMORIES,
  payload: {
    memories
  }
});
